import React from 'react';
import Button from '@primitives/Button';
import cx from 'classnames';
import FileIcon from '@cp/assets/images/icons/FileIcon';
import DownloadIcon from '@cp/assets/images/icons/DownloadIcon';
import { Control, useController } from 'react-hook-form';
import { AgentFormValues } from '@cp/pages/AllAgents/AgentForm/interfaces/types';
import { GenericObject } from '@cp/src/types/CommonConstans';
import { getFileDownload } from '@cp/utils/commonUtils';
import { EditIcon } from '@icons';
import CrossIcon from '@cp/assets/icons/CrossIcon';

type AgentFormDownloadDraCertificateProps = {
  name: keyof AgentFormValues;
  containerClassName?: string;
  control: Control<AgentFormValues, any>;
  rules?: GenericObject;
  isEditDisable: boolean;
};

function AgentFormDownloadDraCertificate({
  name,
  containerClassName,
  control,
  rules,
  isEditDisable
}: AgentFormDownloadDraCertificateProps) {
  const { field } = useController({
    name,
    control,
    rules
  });
  return (
    <>
      <div className="text-[--grayscale-2] text-[14px] ml-[14px] mt-[16px]">DRA Certificate</div>
      <div
        className={cx(
          'flex items-center justify-between text-gray-600 mt-3.5 rounded-lg border border-solid border-[--blue-border] bg-[#F0F6FF] h-[40px] ml-3 gap-2 p-2',
          containerClassName
        )}
      >
        <div className=" flex gap-2 items-center">
          <div>
            <FileIcon width={20} height={20} />
          </div>
          <div className="max-w-[200px] text-ellipsis  overflow-hidden">
            {'Agent DRA Certificate.pdf'}
          </div>
        </div>
        <div className="controls flex items-center gap-1 mr-2">
          {!isEditDisable ? (
            <Button
              variant="text"
              onClick={e => {
                e.preventDefault();
                field.onChange(null);
              }}
            >
              <CrossIcon height={16} width={16} fillColor={'var(--blue-base)'} />
            </Button>
          ) : (
            <Button
              variant="text"
              onClick={e => {
                e.preventDefault();
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                getFileDownload(field?.value?.draCertificate?.uri, true);
              }}
            >
              <DownloadIcon height={20} width={20} />
            </Button>
          )}
        </div>
      </div>
    </>
  );
}

export default AgentFormDownloadDraCertificate;
